/**
 * Returns the layout viewport width in CSS pixels, stable across pinch-zoom.
 *
 * On modern browsers (Chrome Android, iOS Safari) pinch-zoom does not change
 * window.innerWidth — only visualViewport.scale / visualViewport.width change.
 * So window.innerWidth is already the unzoomed layout width and is safe to
 * use for responsive breakpoints without any scale compensation.
 *
 * On desktop, Cmd+/- zoom also leaves visualViewport.scale at 1 while
 * changing window.innerWidth, so normal responsive reflow is preserved.
 */
export function getUnzoomedWidth(): number {
  return window.innerWidth;
}
